import styled from 'styled-components';
import { themeColor } from '../theme/colors';
import { HudIcon } from '../Icons/HudIcons';

export const Value = styled.span`
  color: ${themeColor('textTertiary')};
`;

export const Icon = styled(HudIcon)`
  color: ${themeColor('textTertiary')};
`;

export const Unstyled = styled.div`
  display: inline-flex;
  align-items: center;

  gap: 2px;

  & ${Value}, & ${Icon} {
    color: inherit;
  }
`;

export const Neutral = styled(Unstyled)`
  max-width: fit-content;
  padding: 1px 3px 1px 4px;
  justify-content: center;
  justify-items: center;
  align-items: center;
  align-content: center;
  gap: 2px;
  border-radius: 6px;

  background: ${themeColor('buttonBackground')};
`;

export const Positive = styled(Neutral)`
  background: ${themeColor('positiveSecondary')};

  & ${Value}, & ${Icon} {
    color: ${themeColor('positivePrimary')};
  }
`;

export const Negative = styled(Neutral)`
  background: ${themeColor('redSecondary')};

  & ${Value}, & ${Icon} {
    color: ${themeColor('red')};
  }
`;
